var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.showHeader)?_c('app-navbar'):_vm._e(),_vm._v(" "),_c('toast'),_vm._v(" "),_c('Product-modal'),_vm._v(" "),(_vm.showHeader)?_c('div',{staticClass:"view-wrapper"},[_c('b-container',{attrs:{"fluid":"lg"}},[_c('router-view')],1),_vm._v(" "),(_vm.detectMobile())?_c('MobileNavbar'):_vm._e()],1):_c('router-view')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-639e1f4b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = biWC
// module chunks = 0